import { lazy as lazyLoad } from 'react';

import type { RouteDefinition } from '../../route';
import { route } from './constants';

export const routes: readonly RouteDefinition[] = [
    {
        documentTitle: 'pages.dashboard.featured-learning-opportunities.title',
        page: lazyLoad(async () => {
            const { FeaturedLearningOpportunitiesPage } = await import('./FeaturedLearningOpportunities');

            return { default: FeaturedLearningOpportunitiesPage };
        }),
        path: `/users/:${route.params.userId}/featured-learning-opportunities`,
    },
];
